export default function Marquee({ items, dark = false, className = "" }) {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`px-8 text-[11px] font-medium uppercase tracking-[0.3em] whitespace-nowrap ${dark ? "text-ivory/60" : "text-navy/50"}`}>
            {item}
          </span>
          <span className={`h-1 w-1 rounded-full ${dark ? "bg-bermuda/70" : "bg-bermuda-dark/50"}`} />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-5 ${dark ? "bg-navy" : "bg-sand-light"} ${className}`}
    >
      <div className="animate-marquee flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
